const modify = {
  quantity: {
    presence: {
      allowEmpty: false,
      message: "Quantidade é obrigatório."
    }
  },
  costValue: {
    presence: {
      allowEmpty: false,
      message: "Valor de compra é obrigatório."
    }
  }
};

export default {
  modify
};



// WEBPACK FOOTER //
// ./src/core/constraint/stock-operation.constraint.js